<template>
  <div role="listitem">
    <div
      class="rfp-rr-most-ratings-list-097-or rfp-rr-most-ratings-list-branch rr-all-review-item"
      :class="{ 'rfp-rr-rating-rtl': isRightToLeftActive }"
    >
      <div
        v-if="showHideLocation || showLabelNickname || showHideUserType || showHideAgeRange"
        class="rfp-rr-most-ratings-list-098-or rr-all-review-item-left"
      >
        <p
          class="rfp-rr-most-ratings-list-099-or rr-user-name"
          itemprop="author"
          itemscope
          itemtype="https://schema.org/Person"
          :class="{ 'label-hide-show': !showLabelNickname }"
        >
          <span class="black bold" itemprop="name">{{ review.NickName }}</span>
        </p>
        <p
          v-if="showHideLocation && review.Location"
          class="rfp-rr-most-ratings-list-100-or rr-user-location"
        >
          <span>{{ review.Location }}</span>
        </p>
        <p
          v-if="showHideUserType && review.UserType"
          class="rfp-rr-most-ratings-list-133-or rr-user-name"
        >
          {{ userTypeDesc }}: {{ review.UserType }}
        </p>
        <p
          v-if="review.AgeRange && showHideAgeRange"
          class="rfp-rr-most-ratings-list-102-or rr-user-age"
        >
          {{ ageLabel }}: <span class="bold"> {{ review.AgeRange }}</span>
        </p>
        <p
          v-if="fields.showHideHowDidYouHearAboutTheProduct && review.ProductVoice"
          class="rfp-rr-most-ratings-list-102-or rr-user-age"
        >
          {{ fields.howDidYouHearAboutTheProductLabel }}:
          <span class="bold" v-text="review.ProductVoice"></span>
        </p>
        <p
          v-if="fields.showHideGender && review.Gender"
          class="rfp-rr-most-ratings-list-102-or rr-user-age"
        >
          {{ fields.genderLabel }}: <span class="bold" v-text="review.Gender"></span>
        </p>
      </div>

      <div
        class="rfp-rr-most-ratings-list-103-or rr-all-review-item-right"
        :class="{
          'rfp-rare-full-width-conntainer':
            !showHideLocation && !showLabelNickname && !showHideUserType && !showHideAgeRange,
        }"
      >
        <rfp-ratings-product-star
          :product-rating="review.OverallRating"
          :is-star-rating="true"
          :is-popup="false"
          :rating-class="`rfp-rr-most-ratings-list-104-or review-stars ${isRightToLeftActive ? 'rfp-rr-rating-rtl-float-right' : ''}`"
        />

        <span
          v-if="showCreatedAt"
          class="rfp-rr-most-ratings-list-105-or float-left rr-review-date"
          :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
        >
          - {{ review.CreatedDate }}
        </span>

        <div class="rfp-rr-most-ratings-list-106-or rr-sample-section float-right"></div>
        <h3
          v-if="showHideReviewTitle && review.ReviewTitle"
          class="rfp-rr-most-ratings-list-107-or rr-sub-title black clear"
          v-text="review.ReviewTitle"
        ></h3>
        <p
          v-if="showHideReviewContent"
          class="rfp-rr-most-ratings-list-108-or clear rr-user-review-comment float-left list-mobile-res"
          :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
        >
          {{ review.ReviewContent }}
        </p>

        <rfp-ratings-list-images
          v-if="hasImages(review)"
          :sources="review.Images"
          @modal-open="(position) => $emit('modal-open', position, review.Images)"
        >
        </rfp-ratings-list-images>
        <div
          v-if="reviewStarFields.length"
          class="rfp-rr-most-ratings-list-115-or rr-recomment-product clear"
        >
          <rfp-ratings-product-star
            v-for="(product, key) of reviewStarFields"
            :key="key"
            :label-name="product.label"
            :product-rating="product.rating"
            is-star-rating
            :prop-star-size="product.starSize"
            :is-popup="false"
            class="rfp-rr-most-ratings-list-109-or rr-avg-rating-content float-left mobile-quality-of-product"
            :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
            label-class="rfp-rr-most-ratings-list-110-or rr-label bold float-left"
            rating-class="rfp-rr-most-ratings-list-112-or rfp_rr_start_list"
          />
        </div>

        <div
          v-if="showHideIsProductRecommended"
          class="rfp-rr-most-ratings-list-115-or rr-recomment-product clear"
        >
          <div
            class="rfp-rr-most-ratings-list-116-or rr-sample-section float-left"
            itemprop="reviewBody"
            :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
          >
            <p style="margin-right: 0">
              <img
                :src="review.IsRecommend ? recommendListIcon : notRecommendListIcon"
                class="rfp-rr-most-ratings-list-117-or image-setup-for-list"
                :alt="review.IsRecommend ? recommendIconAltText : notRecommendIconAltText"
                loading="lazy"
              />
            </p>
            <p>{{ review.IsProductRecommended }}</p>
          </div>
        </div>

        <div
          v-if="review.IsProductSuppliedFree && showFreeProduct"
          class="rfp-rr-most-ratings-list-115-or rr-recomment-product clear"
        >
          <p>{{ isProductFreeDisplayText }}</p>
        </div>

        <div class="rfp-rr-most-ratings-list-118-or rr-comment-img-section clear float-left"></div>
        <div class="rfp-rr-most-ratings-list-119-or rr-like-review clear float-left">
          <p
            v-if="showFavorableReviewSection || showCriticalReviewSection"
            :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
          >
            <span>{{ helpfulLabel }}</span>
          </p>
          <div
            class="rfp-rr-most-ratings-list-120-or rr-like-section float-left"
            :class="{ 'rfp-rr-rating-rtl-float-right': isRightToLeftActive }"
          >
            <template v-if="showFavorableReviewSection">
              <p
                role="button"
                tabindex="0"
                @keydown.space.prevent
                @keyup.space="updateReview(review.RRID, true)"
                @keydown.enter="updateReview(review.RRID, true)"
                @click="updateReview(review.RRID, true)"
              >
                <img
                  :src="helpfullIcon"
                  class="image-setup-for-list"
                  :class="`rfp-rr-most-ratings-list-${review.IsHelpfulCookie == 'no' ? '121' : '122'}-or`"
                  :alt="helpfullIconAltText"
                  loading="lazy"
                />
              </p>
              <p>
                <span class="rfp-rr-most-ratings-list-123-or bold">{{ review.HelpfulCount }}</span>
              </p>
            </template>

            <template v-if="showCriticalReviewSection">
              <p
                role="button"
                tabindex="0"
                @keydown.space.prevent
                @keyup.space="updateReview(review.RRID, false)"
                @keydown.enter="updateReview(review.RRID, false)"
                @click="updateReview(review.RRID, false)"
              >
                <img
                  :src="nonHelpfullIcon"
                  class="rfp-rr-most-ratings-list-124-or image-setup-for-list"
                  :alt="nonHelpfullIconAltText"
                  loading="lazy"
                />
              </p>
              <p>
                <span
                  class="rfp-rr-most-ratings-list-126-or bold"
                  v-text="review.NotHelpfulCount"
                ></span>
              </p>
            </template>

            <p>
              <a
                v-if="review.IsReported == 'Report'"
                role="button"
                tabindex="0"
                class="rfp-rr-most-ratings-list-127-or aReported"
                @keydown.space.prevent
                @keyup.space="$emit('rating-summary', review.RRID)"
                @keydown.enter="$emit('rating-summary', review.RRID)"
                @click="$emit('rating-summary', review.RRID)"
              >
                {{ reportText }}
              </a>
              <span
                v-else
                class="rfp-rr-most-ratings-list-128-or aReported"
                v-text="reportedText"
              ></span>
            </p>

            <p v-if="facebookShareEnabled" class="rfp-ratings-social-share">
              <rfp-ratings-social-share
                :url="currentPageUrl"
                :title="review.ProductName"
                :description="review.ReviewContent"
                :quote="review.ReviewTitle"
                :show-fb-media-texts="shareDisplayConfig"
                :facebook-icons="facebookIcon"
                :facebook-icon-alt="facebookIconAlt"
              >
                <template #default="{ networks, networkTag, share, createSharingUrl }">
                  <social-sharing-network
                    :networks="networks"
                    :network-tag="networkTag"
                    :share="share"
                    :create-sharing-url="createSharingUrl"
                    network="facebook"
                  >
                    <p>
                      <img
                        v-if="
                          facebookIcon != '' &&
                          ['Icon and Text', 'Icon'].includes(shareDisplayConfig)
                        "
                        :src="facebookIcon"
                        :title="facebookIconAlt"
                        class="rfp-rr-most-ratings-list-125-or image-setup-for-list"
                        :alt="facebookIconAlt"
                        loading="lazy"
                      />
                    </p>
                    <span
                      v-if="['Icon and Text', 'Text'].includes(shareDisplayConfig)"
                      v-text="facebookCaption"
                    ></span>
                  </social-sharing-network>
                </template>
              </rfp-ratings-social-share>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="rfp-comon-space-declaration"></div>
  </div>
</template>

<script>
import RfpRatingsListImages from '../rfp-ratings-list-images/rfp-ratings-list-images.vue';
import RfpRatingsSocialShare from '../../../rfp-ratings-social-share/Plugins/rfp-ratings-social-share.vue';
import SocialSharingNetwork from '../../../rfp-ratings-social-share/Plugins/social-sharing-network.vue';
import RfpRatingsProductStar from '../../../rfp-ratings-product-star/rfp-ratings-product-star.vue';

export default {
  name: 'rfp-ratings-list-item',
  components: {
    RfpRatingsListImages,
    RfpRatingsSocialShare,
    SocialSharingNetwork,
    RfpRatingsProductStar,
  },
  inject: [
    'ageLabel',
    'currentPageUrl',
    'facebookCaption',
    'facebookIcon',
    'facebookIconAlt',
    'fields',
    'facebookShareEnabled',
    'helpfullIcon',
    'helpfullIconAltText',
    'helpfulLabel',
    'isRightToLeftActive',
    'isProductFreeDisplayText',
    'nonHelpfullIcon',
    'nonHelpfullIconAltText',
    'notRecommendListIcon',
    'notRecommendIconAltText',
    'qualityOfProductLabel',
    'shareDisplayConfig',
    'showCreatedAt',
    'showCriticalReviewSection',
    'showFavorableReviewSection',
    'showFreeProduct',
    'showHideAgeRange',
    'showHideLocation',
    'showHideQualityRating',
    'showHideReviewContent',
    'showHideReviewTitle',
    'showHideUserType',
    'showLabelNickname',
    'showHideIsProductRecommended',
    'starRatingIncrementValue',
    'starRatingMaxRatingValue',
    'starRatingInactiveColor',
    'starRatingActiveColor',
    'starRatingStarSize',
    'recommendListIcon',
    'recommendIconAltText',
    'reportText',
    'reportedText',
    'userTypeDesc',
  ],
  props: {
    review: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    reviewStarFields() {
      const starFields = [
        {
          isEnabled: this.showHideQualityRating,
          label: this.qualityOfProductLabel,
          rating: this.review.QualityRating,
          starSize: this.fields.qualityOfProductStarRatingStarSize,
        },
        {
          isEnabled: this.fields.showHideEffectivenessOfTheProduct,
          label: this.fields.effectivenessOfTheProductLabel,
          rating: this.review.EffectivenessRating,
          starSize: this.fields.effectivenessOfTheProductStarRatingStarSize,
        },
        {
          isEnabled: this.fields.showHideTextureOfTheProduct,
          label: this.fields.textureOfTheProductLabel,
          rating: this.review.TextureRating,
          starSize: this.fields.textureOfTheProductStarRatingStarSize,
        },
        {
          isEnabled: this.fields.showHidepricePositionOfTheProduct,
          label: this.fields.pricePositionOfTheProductLabel,
          rating: this.review.PricePositionRating,
          starSize: this.fields.pricePositionOfTheProductStarRatingStarSize,
        },
      ];

      return starFields.filter((i) => i.isEnabled && i.rating);
    },
  },
  methods: {
    hasImages(item) {
      return !!item?.Images?.length;
    },
    updateReview(id, recommend) {
      if (!recommend && this.review.IsHelpfulCookie !== 'no') {
        return;
      }
      this.$emit('update-review', id, recommend);
    },
  },
};
</script>
